import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BeneListService } from '../../../services/beneList.service';
import { AllocatorService } from '../../../services/allocator.service';
import { Router } from '@angular/router';
import { ModalService } from '../../../services/modal.service';
import { WindowService } from '../../../services/window.service';

import { ModalRouteService } from '../../../services/modal-route.service';

import { BeneListComponent } from '../bene-list.component';

@Component({
  selector: 'bene-list-mmdirect',
  templateUrl: './bene-list.component.mmdirect.html',
  providers: [BeneListService, AllocatorService, ModalService, WindowService],
})
export class BeneListComponentMMDirect extends BeneListComponent {
  @Input() dismiss;

  constructor(
    route: ActivatedRoute,
    windowService: WindowService,
    beneListService: BeneListService,
    allocatorService: AllocatorService,
    modalService: ModalService,
    modalRouteService: ModalRouteService,
    router: Router
  ) {
    super(route, windowService, beneListService, allocatorService, modalService, modalRouteService, router);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }
}
